import clsx from 'clsx'
import React from 'react'
import { Button } from '../../../components'

import './EnterKey.scss'

const EnterKey = ({ value, onChange, isDarkTheme, onPaste }) => {
   return (
      <div className="EnterKey">
         <textarea
            className={clsx(
               'EnterKey__textarea',
               isDarkTheme && 'EnterKey__textarea--dark'
            )}
            rows="10"
            placeholder="Enter Key"
            value={value}
            onChange={e => onChange(e)}
         />
         <Button
            className="EnterKey__paste-btn"
            variant="solid"
            color="primary"
            onClick={onPaste}
            isDarkTheme={isDarkTheme}
         >
            Paste
         </Button>
      </div>
   )
}

export default EnterKey
